import { AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/_services/global.service';
import { GroupEventArgs, GroupService, ToolbarService } from '@syncfusion/ej2-angular-grids';
import { DetailRowService } from '@syncfusion/ej2-angular-grids';
import { SortService } from '@syncfusion/ej2-angular-grids';
import { ApiService } from 'src/app/_services/api.service';
import { GroupSettingsModel } from '@syncfusion/ej2-angular-grids';
import { MenuItem } from 'primeng/api';
import  itlocale  from './../../itgridlocale.json';
import { L10n } from '@syncfusion/ej2-base';
import { OverlayPanel } from 'primeng/overlaypanel';
import { forkJoin } from 'rxjs';




L10n.load(itlocale);

@Component({
  selector: 'app-todolist',
  templateUrl: './todolist.component.html',
  styleUrls: ['./todolist.component.css'],
  providers: [SortService,ToolbarService,GroupService],
  encapsulation: ViewEncapsulation.None,
})
export class TodolistComponent implements OnInit,AfterViewInit {
  @ViewChild('gridTodoList')public gridTodoList: any;
  @ViewChild("op") op: OverlayPanel;
  public toolbar: string[];
  public groupByItems:MenuItem[];
  public rowData:any=[];
  public rowDataAll:any=[];
  public currentRecord:any={};
  public locale: any = "it";
  public filtraGiorni:string="A";
  public filtraGiorniList:any[]=[
    {label:"Settimana",value:"W"},
    {label:"Mese",value:"M"},
    {label:"Ultimi 30 gg",value:"30"},
    {label:"Tutti",value:"A"},
  ];
  public expcol:string="C";
  public expcolList:any[]=[
    {label:"Espandi",value:"E"},
    {label:"Coprimi",value:"C"},
 
  ];

  public groupOptions?: GroupSettingsModel;

  constructor(
    private apiService: ApiService,
    public globalService : GlobalService,
    public router: Router,
  ) { }
  ngOnInit(): void {
   
    this.groupByItems=[
      {
        label:'Raggruppa per Tipo', 
        command: () => {
          
          this.gridTodoList.groupColumn('tipologia'); 
        }
      },
      {
        label:'Raggruppa per Provenienza', 
        command: () => {
          
          this.gridTodoList.groupColumn('ufficio_prov'); 
        }
      },
      {
        label:'Nessun raggruppamento', 
        command: () => {
          this.gridTodoList.clearGrouping(''); 
        }
      },
    ];
    this.toolbar = ['Search'];

    let params= {id_user:this.globalService.loggedUser.id};
    this.apiService.get('users/logininfokpi',params).subscribe(data => {
      let params=data.Result[0];
     
      let segnalazioni=this.apiService.get('todo/segnalazioniaperte',params);
      let ticketdicompetenza=this.apiService.get('todo/ticketdicompetenza',params);
      let ordinidaapprovare=this.apiService.get('todo/ordinidaapprovare',params);
      let nonconformitadaassegnare=this.apiService.get('todo/nonconformitadaassegnare',params);
      let arkimanaperti=this.apiService.get('todo/arkimantodolist',params);
      let daapprovare=this.apiService.get('todo/daapprovare',params);
      let arkiguestaperti=this.apiService.get('todo/arkiguestaperti',params);
      let recruitingdaevadere=this.apiService.get('todo/recruitingdaevadere',params);
   
      let tasks=this.apiService.get('todo/tasks',params);
      
      forkJoin([segnalazioni,
        ticketdicompetenza,
        ordinidaapprovare,
        nonconformitadaassegnare,
        arkimanaperti,
        daapprovare,
        arkiguestaperti,
        tasks,
        recruitingdaevadere]).subscribe(data => {
      
        this.rowData=data[0].Result;
        this.rowData=this.rowData.concat(data[1].Result); 
        this.rowData=this.rowData.concat(data[2].Result); 
        this.rowData=this.rowData.concat(data[3].Result); 
        this.rowData=this.rowData.concat(data[4].Result); 
        this.rowData=this.rowData.concat(data[5].Result); 
        this.rowData=this.rowData.concat(data[6].Result); 
        this.rowData=this.rowData.concat(data[7].Result); 
        this.rowData=this.rowData.concat(data[8].Result); 
        this.rowDataAll=this.rowData;
        this.groupOptions = {showDropArea: true, showGroupedColumn:false, columns: [] };
        this.gridTodoList.localeObj.currentLocale.EmptyRecord = 'Nessun dato presente'; 
      });
    });

    
  
  }

  ngAfterViewInit(){

  }
  onLoad() { 
    this.gridTodoList.localeObj.currentLocale.EmptyRecord = 'Caricamento in corso...'; 
  }
  actionComplete(args: GroupEventArgs) {
  if (args.requestType === 'grouping'){
    window.scroll({ 
      top: 0, 
      left: 0 
    });
    this.gridTodoList.groupModule.collapseAll();
  }
 }

 okExpCol(){
  if(this.expcol=="E"){
    this.gridTodoList.groupModule.expandAll();
  } else {
    this.gridTodoList.groupModule.collapseAll();
  }
 
 }

  okFiltraGiorni(){
    console.log(this.filtraGiorni);
    if(this.filtraGiorni=='A'){
      this.rowData=this.rowDataAll;
    } 
    if(this.filtraGiorni=='W'){
      this.rowData=this.rowDataAll.filter((x)=>x.period=='W');
    }
    if(this.filtraGiorni=='M'){
      this.rowData=this.rowDataAll.filter((x)=>(x.period==this.filtraGiorni || x.period=='W'));
    }
    if(this.filtraGiorni=='30'){
      this.rowData=this.rowDataAll.filter((x)=>(x.period==this.filtraGiorni || x.period=='W' || x.period=='M'));
    }

  }

  previous(){
    if(this.currentRecord.index>0){
      event.preventDefault();
      this.currentRecord.index--;
      let rowElem = this.gridTodoList.getRowByIndex(this.currentRecord.index);  // get the corresponding row 
      let rec = this.gridTodoList.getRowInfo(rowElem).rowData;  // get rowData from getRowInfo 
      if(rec){
        let ci=this.currentRecord.index;
        this.currentRecord=rec;
        this.currentRecord.index=ci;
      }
    }
  }

  next(event){
    event.preventDefault();
    this.currentRecord.index++;
    let rowElem = this.gridTodoList.getRowByIndex(this.currentRecord.index);  // get the corresponding row 
    let rec = this.gridTodoList.getRowInfo(rowElem).rowData;  // get rowData from getRowInfo 
    if(rec){
      let ci=this.currentRecord.index;
      this.currentRecord=rec;
      this.currentRecord.index=ci;
    }
  }

  apri(data){
 
    
    if(data.modulo=='segnalazioni'){
      //    window.open(environment.JAVALOGINURL+'/sign/gestioneSegnalazioni/ServletSign?oper=7&id_sign='+data.id,'_blank');
      let logInfo = JSON.parse(localStorage.getItem("logInfo"));
      let params={
        oper:6,
        id_sign:data.id,
        password:logInfo.password,
        userNamelogin:logInfo.username
      }
      this.globalService.submitForm('sign/login/LogonServletSign','POST',params);
    }
    if(data.modulo=='manutenzioni'){
      let logInfo = JSON.parse(localStorage.getItem("logInfo"));
      let params={
        oper:1,
        reind:'manutenzione',
        id_manutenzione:data.id,
        password:logInfo.password,
        userNamelogin:logInfo.username
      }
      this.globalService.submitForm('arkiman/login/LogonServletMAN','POST',params);
    }
   
    if(data.modulo=='ordini'){
      let logInfo = JSON.parse(localStorage.getItem("logInfo"));
      let params={
        oper:3,
        id_ordine:data.id,
        password:logInfo.password,
        userNamelogin:logInfo.username
      }
      this.globalService.submitForm('arkifatt/login/LogonServletAF','POST',params);
    }

    if(data.modulo=='ticket'){
      let logInfo = JSON.parse(localStorage.getItem("logInfo"));
      let params={
        password:logInfo.password,
        userNamelogin:logInfo.username
      }

      this.globalService.submitForm('arkiweb/login/LogonServletAw?oper=3&redirectS=ServletTicket&id_ticket='+data.id,'POST',params);
    }
    if(data.modulo=='protocolli'){
      let logInfo = JSON.parse(localStorage.getItem("logInfo"));
      let params={
        password:logInfo.password,
        userNamelogin:logInfo.username
      }
      this.globalService.submitForm('arkiweb/login/LogonServletAw?oper=3&redirectS=ServletProtocolli','POST',params);
    }
    if(data.modulo=='procedure'){
      let logInfo = JSON.parse(localStorage.getItem("logInfo"));
      let params={
        password:logInfo.password,
        userNamelogin:logInfo.username
      }
      this.globalService.submitForm('arkiweb/login/LogonServletAw?oper=3&redirectS=ServletProcedure','POST',params);
    }
    if(data.modulo=='moduli'){
      let logInfo = JSON.parse(localStorage.getItem("logInfo"));
      let params={
        password:logInfo.password,
        userNamelogin:logInfo.username
      }
      this.globalService.submitForm('arkiweb/login/LogonServletAw?oper=5&redirectS=ServletModuli','POST',params);
    }
    if(data.modulo=='documenti'){
      let logInfo = JSON.parse(localStorage.getItem("logInfo"));
      let params={
        password:logInfo.password,
        userNamelogin:logInfo.username
      }
      this.globalService.submitForm('login/LogonServletAw?oper=4&redirectS=ServletDocumenti','POST',params);
    }
    if(data.modulo=='policy'){
      let logInfo = JSON.parse(localStorage.getItem("logInfo"));
      let params={
        password:logInfo.password,
        userNamelogin:logInfo.username
      }
      this.globalService.submitForm('login/LogonServletAw?oper=4&redirectS=ServletDocumenti&f_cat=2','POST',params);
    }
    if(data.modulo=='arkiguest'){
      let logInfo = JSON.parse(localStorage.getItem("logInfo"));
      let params={
        oper:2,
        timbro:data.id,
        password:logInfo.password,
        userNamelogin:logInfo.username
      }
      this.globalService.submitForm('arkiguest/login/LogonServletAG','POST',params);
    }
    if(data.modulo=='recruiting'){
      let logInfo = JSON.parse(localStorage.getItem("logInfo"));
      let params={
        password:logInfo.password,
        userNamelogin:logInfo.username
      }
      this.globalService.submitForm('assunzioni/login/LogonServletAs?oper=7&timbro='+data.id,'POST',params);
    }

    if(data.tipologia=='Tasks'){
      let logInfo = JSON.parse(localStorage.getItem("logInfo"));
      let params={
        password:logInfo.password,
        userNamelogin:logInfo.username
      }    
      this.globalService.submitForm('arkiweb/login/LogonServletAw?redirectS=ServletTask&oper=5&id_task='+data.id,'POST',params);
    }
    
    if(data.modulo=='nonconformita'){
      let logInfo = JSON.parse(localStorage.getItem("logInfo"));
      let params={
        password:logInfo.password,
        userNamelogin:logInfo.username
      }    
      this.globalService.submitForm('sign/login/LogonServletSign?oper=8&id_nc='+data.id,'POST',params);
    }
   
  
  }

  
  showdetail(data,event){
    this.currentRecord=data;
    this.op.hide();
    setTimeout(()=>{
      this.op.show(event);
    },100);
  }


}
